import React from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { IAddTemplatePayload } from "../../common/types/templateTypes";

interface Props {
  show: boolean;
  mode: "add" | "edit";
  form: IAddTemplatePayload;
  setForm: React.Dispatch<React.SetStateAction<IAddTemplatePayload>>;
  isBusy: boolean;
  onClose: () => void;
  onSubmit: () => void;
}

const AddEditTemplateModal = ({
  show,
  mode,
  form,
  setForm,
  isBusy,
  onClose,
  onSubmit,
}: Props) => {
  const isEdit = mode === "edit";

  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      size="lg"
      className="modal-container"
    >
      <Modal.Header closeButton>
        <Modal.Title>{isEdit ? "Edit Template" : "Add Template"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Row className="g-2">
            <Col sm={12}>
              <Form.Label>Template ID*</Form.Label>
              <Form.Control
                type="number"
                value={form.templateId || ""}
                disabled={isEdit}
                onChange={(e) =>
                  setForm({
                    ...form,
                    templateId: e.target.value
                      ? Number(e.target.value)
                      : undefined,
                  })
                }
              />
            </Col>
            <Col sm={12}>
              <Form.Label>Template Name*</Form.Label>
              <Form.Control
                value={form.name}
                onChange={(e) => setForm({ ...form, name: e.target.value })}
              />
            </Col>
            <Col sm={12}>
              <Form.Label>
                {isEdit ? "Replace image file (optional)" : "Upload image file*"}
              </Form.Label>
              <Form.Control
                type="file"
                accept="image/*"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  setForm({
                    ...form,
                    file:
                      e.target.files && e.target.files[0]
                        ? e.target.files[0]
                        : null,
                  })
                }
              />
            </Col>
            <Col sm={12}>
              <Form.Check
                type="checkbox"
                label="Public"
                checked={!!form.public}
                onChange={(e) =>
                  setForm({ ...form, public: e.target.checked })
                }
              />
            </Col>
            <Col sm={12}>
              <Form.Label>Flags</Form.Label>
              <div className="template-assign-flags">
                <Form.Check
                  type="checkbox"
                  label="Require Heading"
                  checked={!!form.templateReqHeading}
                  onChange={(e) =>
                    setForm({ ...form, templateReqHeading: e.target.checked })
                  }
                />
                <Form.Check
                  type="checkbox"
                  label="Require Message"
                  checked={!!form.templateReqMessage}
                  onChange={(e) =>
                    setForm({ ...form, templateReqMessage: e.target.checked })
                  }
                />
                <Form.Check
                  type="checkbox"
                  label="Require Icon"
                  checked={!!form.templateReqIcon}
                  onChange={(e) =>
                    setForm({ ...form, templateReqIcon: e.target.checked })
                  }
                />
                <Form.Check
                  type="checkbox"
                  label="Require Logo"
                  checked={!!form.templateReqLogo}
                  onChange={(e) =>
                    setForm({ ...form, templateReqLogo: e.target.checked })
                  }
                />
                <Form.Check
                  type="checkbox"
                  label="Require ZipCode"
                  checked={!!form.templateReqZipCode}
                  onChange={(e) =>
                    setForm({ ...form, templateReqZipCode: e.target.checked })
                  }
                />
              </div>
            </Col>
            <Col sm={6}>
              <Form.Label>Firmware Version</Form.Label>
              <Form.Control
                value={form.firmwareVersion}
                onChange={(e) =>
                  setForm({ ...form, firmwareVersion: e.target.value })
                }
              />
            </Col>
            <Col sm={6}>
              <Form.Label>Max Message Chars</Form.Label>
              <Form.Control
                type="number"
                value={form.maxAlertMessageCharacter ?? ""}
                onChange={(e) =>
                  setForm({
                    ...form,
                    maxAlertMessageCharacter: e.target.value
                      ? Number(e.target.value)
                      : 0,
                  })
                }
              />
            </Col>
            <Col sm={6}>
              <Form.Label>Max Title Chars</Form.Label>
              <Form.Control
                type="number"
                value={form.maxAlertTitleCharacter ?? ""}
                onChange={(e) =>
                  setForm({
                    ...form,
                    maxAlertTitleCharacter: e.target.value
                      ? Number(e.target.value)
                      : 0,
                  })
                }
              />
            </Col>
            <Col sm={6}>
              <Form.Label>Max Message Lines</Form.Label>
              <Form.Control
                type="number"
                value={form.maxAlertMessageLine ?? ""}
                onChange={(e) =>
                  setForm({
                    ...form,
                    maxAlertMessageLine: e.target.value
                      ? Number(e.target.value)
                      : 0,
                  })
                }
              />
            </Col>
          </Row>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button className="btn-cancel" onClick={onClose} disabled={isBusy}>
          Cancel
        </Button>
        <Button className="btn-style" onClick={onSubmit} disabled={isBusy}>
          {isEdit ? "Save" : "Add"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddEditTemplateModal;
